import React, { Component } from 'react';
import { connect } from 'react-redux';
import IndexLink from '../../shared/IndexLink/IndexLink';
import Link from '../../shared/Link/Link';
import { withRouter, browserHistory } from 'react-router';

import { primary_light } from '../../shared/lib/colors';
import { jsx, css } from '@emotion/core';

import {
  removeFromCart,
  updateCartQuantity,
  getCartTotal,
  getCartTotalDiscountedCoupon,
  getDiscount,
  maxAddable,
  getMaxAddable,
  getCartTotalDiscountable,
} from '../../../redux/modules/cart';
import {
  setCoupon,
  resetCoupon,
  getCoupon,
  isValidCoupon,
} from '../../../redux/modules/checkout';

import {
  removeFromCartEvent,
  checkoutStep,
  pushRemarketingEvent,
} from '../../shared/lib/gaEnhancedEcommerce';

import Price from '../../shared/Price/Price';
import ProdottoCarrello from './ProdottoCarrello/ProdottoCarrello';
import MessaggioChiusura from '../../shared/MessaggioChiusura/MessaggioChiusura';

import { FaCheck } from 'react-icons/fa';
import './Carrello.scss';
import Button from '../../shared/Button/Button';
import IubendaCookieSolution from '../../../utils/iubenda';
import {
  ga4AddToCart,
  ga4BeginCheckout,
  ga4RemoveFromCart,
  ga4ViewCart,
} from '../../shared/lib/ga4EnhancedEcommerce';
import {
  fkmxAddToCart,
  fkmxBeginCheckout,
  fkmxRemoveFromCart,
  fkmxViewCart,
} from '../../shared/lib/farmakomMetrics';
import { Helmet } from 'react-helmet';
import { getSHA256Hash } from '../../../utils/sha256';
import { criteoViewBasket } from '../../shared/lib/criteo';
import {
  gtmToGa4AddToCart,
  gtmToGa4BeginCheckout,
  gtmToGa4RemoveFromCart,
  gtmToGa4ViewCart,
} from '../../shared/lib/gtmEnhancedEcommerce';
import { cleanImage } from '../../../utils/images';

class Carrello extends Component {
  ///////////////////////////////////
  // GOOGLE ANALYTICS: STEP 1
  gaStep1(cart) {
    const productsGA = cart.map(p => ({
      id: p.code || '',
      name: p.name,
      category: p.categoryName,
      brand: p.brand,
      price: p.price,
      quantity: p.quantity,
    }));
    // SEND EVENT AFTER 1 SEC
    setTimeout(() => {
      checkoutStep(productsGA, 1);
    }, 1000);
  }

  componentDidMount() {
    // IUBENDA
    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );

    // Eventuale coupon da Worldz
    const couponQuery = this.props.router.location.query.c;

    // Eventuale coupon da localStorage
    const couponLs =
      typeof localStorage !== 'undefined' ? localStorage.getItem('coupon') : '';
    let currentCouponCode = this.props.coupon.code;

    // Eliminazione coupon da Worldz
    if (couponQuery === '') {
      this.props.setCoupon('');
      currentCouponCode = '';
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('coupon', '');
      }
    } else {
      // No querystring c=<vuoto>
      const presetCoupon = couponQuery || couponLs;
      if (presetCoupon) {
        // Se coupon da Worldz, lo setto in Redux e lo testo con API
        this.props.setCoupon(presetCoupon);
        currentCouponCode = presetCoupon;
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem('coupon', presetCoupon);
        }
      }
    }

    // Test coupon (potrebbe non essere più
    // valido in base al contenuto del carrello
    this.props.getCoupon(currentCouponCode);

    // GOOGLE ANALYTICS STEP 1
    if (this.props.advancedGa && this.props.cart) {
      this.gaStep1(this.props.cart);
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('cart', this.props.cart);
    }

    // CRITEO CART TAG
    if (this.props.hasCriteo) {
      if (this.props.cart.length > 0) {
        // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
        this.renderCriteoTag();
      }
    }

    // GTM VIEW CART
    if (this.props.hasGoogleTagManager) {
      gtmToGa4ViewCart(this.props.cart, this.props.cartTotalDiscounted);
    }

    // GA4 VIEW CART
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4ViewCart(this.props.cart, this.props.cartTotalDiscounted);
    }

    // FKMX VIEW CART
    if (this.props.hasFarmakomMetrics) {
      fkmxViewCart(this.props.cart, this.props.cartTotalDiscounted);
    }
  }

  componentDidUpdate(oldProps) {
    if (
      this.props.cart.length !== oldProps.cart.length &&
      this.props.cart.length > 0
    ) {
      if (this.props.hasCriteo) {
        //   // const iubenda = new IubendaCookieSolution(
        //   //   this.props.hasIubendaCookieSolution
        //   // );
        //   // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
        this.renderCriteoTag();
      }

      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('cart', this.props.cart);
      }

      // GTM VIEW CART
      if (this.props.hasGoogleTagManager) {
        gtmToGa4ViewCart(this.props.cart, this.props.cartTotalDiscounted);
      }

      // GA4 VIEW CART
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewCart(this.props.cart, this.props.cartTotalDiscounted);
      }

      // FKMX VIEW CART
      if (this.props.hasFarmakomMetrics) {
        fkmxViewCart(this.props.cart, this.props.cartTotalDiscounted);
      }
    }
  }

  renderCriteoTag = async () => {
    // <!-- Criteo Basket/Cart Tag -->
    const user = this.props.user.data;
    const email = (user && user.email) || '';
    const zipcode = (user && user.shipping && user.shipping.zipcode) || '';

    criteoViewBasket(
      this.props.criteoAccountId,
      {
        email,
        zipcode,
      },
      this.props.cart
    );
    // <!-- END Criteo Basket/Cart Tag -->
  };

  componentWillReceiveProps(nextProps) {
    // GOOGLE ANALYTICS STEP 1
    if (nextProps.advancedGa && nextProps.cart !== this.props.cart) {
      this.gaStep1(nextProps.cart);
    }
  }

  decrement = product => event => {
    event.preventDefault();
    if (!product.isFreeCorrelatedProduct) {
      const quantity = this.props.cart
        .filter(pr => pr.id === product.id)
        .reduce((acc, current) => acc + current.quantity, 0);
      if (quantity > 1) {
        this.props.updateCartQuantity(product.id, quantity - 1).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });
      }

      // GTM REMOVE FROM CART
      if (this.props.hasGoogleTagManager) {
        gtmToGa4RemoveFromCart({ ...product, quantity: 1 });
      }

      // GA4 REMOVE FROM CART
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4RemoveFromCart({ ...product, quantity: 1 });
      }

      // FKMX REMOVE FROM CART
      if (this.props.hasFarmakomMetrics) {
        fkmxRemoveFromCart({ ...product, quantity: 1 });
      }
    }
  };

  increment = product => event => {
    event.preventDefault();

    if (!product.isFreeCorrelatedProduct) {
      const maxAddable = getMaxAddable(this.props.globalState, product);
      const { minNumInCart } = product;

      if (maxAddable > 0) {
        // la quantity del product diventa la somma delle quantity considerando anche i free
        const quantity = this.props.cart
          .filter(pr => pr.id === product.id)
          .reduce((acc, current) => acc + current.quantity, 0);

        // Posso aggiungere al carrello
        let newQuantity = quantity + 1;

        // Se c'è una quantità minima carrello e non l'ho raggiunta
        if (minNumInCart && quantity < minNumInCart) {
          // La nuova quantità è il minimo tra
          // la quantità minima carrello e il numero
          // massimo di pezzi che possono stare nel carrello
          newQuantity = Math.min(minNumInCart, quantity + maxAddable);
        }

        // Applico nuova quantità
        this.props.updateCartQuantity(product.id, newQuantity).then(() => {
          // Ricalcolo applicabilità coupon
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });

        // GTM ADD TO CART
        if (this.props.hasGoogleTagManager) {
          gtmToGa4AddToCart({ ...product, quantity: 1 });
        }

        // GA4 ADD TO CART
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4AddToCart({ ...product, quantity: 1 });
        }

        // FKMX ADD TO CART
        if (this.props.hasFarmakomMetrics) {
          fkmxAddToCart({ ...product, quantity: 1 });
        }
      }
    }
  };

  remove = product => event => {
    event.preventDefault();

    if (!product.isFreeCorrelatedProduct) {
      if (
        this.props.cart.find(
          pr => pr.id === product.id && !!pr.isFreeCorrelatedProduct
        )
      ) {
        // aggiorno la quantità
        const quantity = 1;
        this.props.updateCartQuantity(product.id, quantity).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });
      } else {
        // rimuovo
        this.props.removeFromCart(product).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });

        if (this.props.advancedGa) {
          removeFromCartEvent({
            id: product.code || '',
            name: product.name,
            category: product.categoryName,
            brand: product.brand,
            price: product.price,
            quantity: product.quantity,
          });
        }

        // GTM REMOVE FROM CART
        if (this.props.hasGoogleTagManager) {
          gtmToGa4RemoveFromCart(product);
        }

        // GA4 REMOVE FROM CART
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4RemoveFromCart(product);
        }

        // FKMX REMOVE FROM CART
        if (this.props.hasFarmakomMetrics) {
          fkmxRemoveFromCart(product);
        }
      }
    } else if (!!product.isFreeCorrelatedProduct) {
      if (
        this.props.cart.find(
          pr => pr.id === product.id && !pr.isFreeCorrelatedProduct
        )
      ) {
        // aggiorno la quantità
        const quantity = 1;
        this.props.updateCartQuantity(product.id, quantity).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });
      } else {
        this.props.removeFromCart(product).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });

        if (this.props.advancedGa) {
          removeFromCartEvent({
            id: product.code || '',
            name: product.name,
            category: product.categoryName,
            brand: product.brand,
            price: product.price,
            quantity: product.quantity,
          });
        }

        // GTM REMOVE FROM CART
        if (this.props.hasGoogleTagManager) {
          gtmToGa4RemoveFromCart(product);
        }

        // GA4 REMOVE FROM CART
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4RemoveFromCart(product);
        }

        // FKMX REMOVE FROM CART
        if (this.props.hasFarmakomMetrics) {
          fkmxRemoveFromCart(product);
        }
      }
    }
  };

  checkCoupon = event => {
    this.props.setCoupon(event.target.value);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('coupon', event.target.value);
    }
    if (event.target.value.length > 2) {
      this.props.getCoupon(event.target.value);
    }
  };

  handleProceed = () => {
    const { user } = this.props;
    if (
      user.data.billing.taxCode === '' ||
      user.data.billing.address1 === '' ||
      user.data.billing.phone === '' ||
      user.data.billing.zipcode === '' ||
      user.data.billing.city === '' ||
      user.data.billing.province === '' ||
      user.data.shipping.phone === '' ||
      user.data.shipping.zipcode === '' ||
      user.data.shipping.city === '' ||
      user.data.shipping.address1 === ''
    ) {
      browserHistory.push('/profilo?modifica=true');
    } else {
      // GTM BEGIN CHECKOUT
      if (this.props.hasGoogleTagManager) {
        gtmToGa4BeginCheckout(this.props.cart, this.props.cartTotalDiscounted);
      }

      // GA4 BEGIN CHECKOUT
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4BeginCheckout(this.props.cart, this.props.cartTotalDiscounted);
      }

      // FKMX BEGIN CHECKOUT
      if (this.props.hasFarmakomMetrics) {
        fkmxBeginCheckout(this.props.cart, this.props.cartTotalDiscounted);
      }

      // CHECK SE C'é UN COUPON E NON è VALIDO RIMUOVO
      if (!this.props.validCoupon) {
        this.props.resetCoupon();
        localStorage.removeItem('coupon');
      }

      // CHECK SE CI SONO PRODOTTI CHE RICHIEDONO UNA RICETTA
      const prescription = this.props.cart.find(
        product => !!product.prescription
      );
      if (!!prescription) {
        browserHistory.push('/ricetta');
      } else {
        browserHistory.push('/spedizione');
      }
    }
  };

  renderCartItems() {
    return (
      this.props.cart
        // here we sort products so that free products are always at the end
        .sort((a, b) => {
          if (a.isFreeCorrelatedProduct && !b.isFreeCorrelatedProduct) {
            return 1;
          } else if (!a.isFreeCorrelatedProduct && b.isFreeCorrelatedProduct) {
            return -1;
          } else {
            return 0;
          }
        })
        .map(product => {
          return (
            <ProdottoCarrello
              key={`${product.id}${
                product.isFreeCorrelatedProduct ? '_free' : ''
              }`}
              product={product}
              onIncrement={this.increment(product)}
              onDecrement={this.decrement(product)}
              onRemove={this.remove(product)}
              primaryColor={this.props.primaryColor}
              uiVariantButton={this.props.uiVariantButton}
            />
          );
        })
    );
  }

  renderTotalButtons = (isMobile, minQuantityNotRespected) => {
    const {
      primaryColor,
      cartTotalDiscounted,
      validCoupon,
      discount,
      uiVariantButton,
    } = this.props;

    return (
      <div
        className={`total-buttons ${isMobile ? 'mobile' : 'desktop'}`}
        style={{
          backgroundColor: isMobile ? primaryColor : 'transparent',
        }}
      >
        <div
          className={`total ${
            isMobile && (validCoupon || discount.length > 4)
              ? 'with-discount'
              : ''
          }`}
        >
          {isMobile && (
            <div className="discount-ok mobile">
              {validCoupon && (
                <span className="promo-discount-amount">
                  <span className="promo-discount">Sconto:</span>
                  <span className="promo-amount">
                    - <Price amount={discount} />
                  </span>
                </span>
              )}
              {discount.length > 4 && (
                <span className="promo-amount">{discount}</span>
              )}
            </div>
          )}
          <div className="total-discounted">
            <span className="text">Totale:</span>
            <span className="amount">
              <Price amount={cartTotalDiscounted} />
            </span>
          </div>
        </div>

        <div className="buttons">
          <IndexLink
            to="/"
            className={`btn btn-back ${
              isMobile ? 'btn-inverse' : 'btn-outline btn-thick btn-cart'
            }`}
            style={{
              color: isMobile
                ? '#fff'
                : uiVariantButton === '3'
                ? '#4f4f4f'
                : primaryColor,
            }}
          >
            Continua la spesa
          </IndexLink>
          {!minQuantityNotRespected && (
            <>
              {this.props.isAuthenticated ? (
                <Button
                  onClick={this.handleProceed}
                  className={`btn ${
                    isMobile ? 'btn-inverse' : 'btn-primary btn-thick btn-cart'
                  }`}
                  style={{
                    color: isMobile ? primaryColor : '#fff',
                    backgroundColor: isMobile ? '#fff' : primaryColor,
                    borderColor: isMobile ? '#fff' : primaryColor,
                    opacity: minQuantityNotRespected ? 0.6 : 1,
                  }}
                >
                  Procedi all'acquisto
                </Button>
              ) : (
                <Link
                  to="/accedi"
                  className={`btn ${
                    isMobile ? 'btn-inverse' : 'btn-primary btn-thick btn-cart'
                  }`}
                  style={{
                    color: isMobile ? primaryColor : '#fff',
                    backgroundColor: isMobile ? '#fff' : primaryColor,
                    borderColor: isMobile ? '#fff' : primaryColor,
                  }}
                >
                  Procedi all'acquisto
                </Link>
              )}
            </>
          )}
        </div>
      </div>
    );
  };

  renderCouponWarning = () => {
    if (
      !this.props.couponIsAppliedToSopOtc &&
      this.props.coupon.minAmount &&
      this.props.cart.every(
        product =>
          product.type === 'farmaci' || product.taxCreditType === 'DRUG'
      )
    ) {
      return (
        <div className="coupon-warning">
          Per normativa il coupon <b>NON</b> può essere applicato a farmaci e
          omeopatici.
        </div>
      );
    } else if (
      !this.props.couponIsAppliedToSopOtc &&
      this.props.coupon.minAmount &&
      this.props.cart.some(
        product =>
          product.type === 'farmaci' || product.taxCreditType === 'DRUG'
      )
    ) {
      return (
        <div className="coupon-warning">
          Per normativa il coupon non sarà applicato a farmaci e omeopatici, ma{' '}
          <b>SOLO</b> ai parafarmaci.
        </div>
      );
    } else if (
      !this.props.coupon.loading &&
      this.props.coupon.minAmount > 0 &&
      this.props.cartTotalDiscountable < this.props.coupon.minAmount
    ) {
      return (
        <div className="coupon-warning">
          Aggiungi ancora{' '}
          <b>
            {Math.round(
              (this.props.coupon.minAmount - this.props.cartTotalDiscountable) *
                100
            ) / 100}{' '}
            €
          </b>{' '}
          per attivare il coupon.
        </div>
      );
    }
  };

  render() {
    const {
      coupon,
      discount,
      validCoupon,
      primaryColor,
      location,
      cart,
      uiVariantInputText,
      uiVariantButton,
      siteName,
      logoImage,
      checkout,
    } = this.props;

    const carrelloStyle = css`
      .title {
        background-color: ${primary_light(primaryColor)};
        border-radius: ${uiVariantButton === '1'
          ? '12px'
          : uiVariantButton === '3'
          ? '30px'
          : 0};
      }
      .promo .promo-code {
        input {
          border-radius: ${uiVariantInputText === '1'
            ? '12px'
            : uiVariantInputText === '3'
            ? '30px'
            : 0};

          &:focus {
            box-shadow: none;
            border-color: ${primaryColor}!important;
          }
        }
        .promo-check {
          color: ${primaryColor}!important;
        }
      }
    `;

    const minQuantityNotRespected = cart.reduce((acc, product) => {
      const minQuantityNotRespectedOnProduct =
        product.minNumInCart && product.quantity < product.minNumInCart;
      return acc || minQuantityNotRespectedOnProduct;
    }, false);

    const changedQuantity = cart.filter(
      product =>
        !!product.availableLessThanRequested &&
        typeof product.availableLessThanRequested === 'number'
    );

    return (
      <div className="carrello" css={carrelloStyle}>
        <Helmet
          title="Carrello"
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia - Carrello`,
            },
            {
              name: 'keywords',
              content: `${siteName}, Ecommerce Farmacia - Carrello`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:title',
              content: `Carrello | ${siteName} - Ecommerce Farmacia`,
            },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia - Carrello`,
            },
            { property: 'og:image', content: cleanImage(logoImage) },
          ]}
        />
        <div className="container">
          <h1>Carrello</h1>

          {(location.query.na || !!changedQuantity.length) && (
            <div className="not-available-box">
              <p>
                Purtroppo almeno un prodotto ora non è più disponibile nella
                quantità che avevi inserito nel carrello.
              </p>
              <p>
                Abbiamo aggiornato il carrello con le quantità effettivamente
                disponibili (<span style={{ color: '#c00' }}>in rosso</span>).
              </p>
              {changedQuantity.map(product => {
                const singularOrPlurale =
                  product.availableLessThanRequested === 1 ? 'o' : 'i';
                return (
                  <p style={{ fontWeight: 'bold' }}>
                    {` - ${product.name}, rimoss${singularOrPlurale} ${product.availableLessThanRequested} pezz${singularOrPlurale}`}
                  </p>
                );
              })}
            </div>
          )}

          <div className="title">
            <div className="t-1">Prodotto</div>
            <div className="t-2">Prezzo</div>
            <div className="t-3">Quantità</div>
            <div className="t-4">Subtotale</div>
          </div>

          {this.renderCartItems()}

          {minQuantityNotRespected && (
            <div className="min-in-cart">
              Non è possibile procedere all'ordine perché almeno un prodotto non
              rispetta la quantità minima.
            </div>
          )}

          <div className="promo">
            <span className="promo-text">Hai un codice promo?</span>
            <form className="promo-code">
              <input
                type="text"
                className="form-control"
                placeholder="Inseriscilo qui!"
                value={coupon.code}
                onChange={this.checkCoupon}
              />
              {validCoupon && (
                <div className="promo-check">
                  <FaCheck />
                </div>
              )}
            </form>

            <div className="discount-ok desktop">
              {validCoupon && (
                <span className="promo-discount-amount">
                  <span className="promo-discount">Sconto:</span>
                  <span className="promo-amount">
                    - <Price amount={discount} />
                  </span>
                </span>
              )}
              {discount.length > 4 && (
                <span className="promo-amount">{discount}</span>
              )}
            </div>
          </div>

          <div className="message">
            <MessaggioChiusura type="cart" />
          </div>

          {this.renderCouponWarning()}

          {this.renderTotalButtons(
            this.props.isMobile,
            minQuantityNotRespected
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    user: state.user,
    cart: state.cart,
    checkout: state.checkout,
    coupon: state.checkout.coupon,
    isAuthenticated: state.user.authenticated,
    siteName: state.store.data.datiFarmacia.siteName,
    logoImage: state.store.data.loghiTemplate.logoImage,
    globalState: state,
    cartTotal: getCartTotal(state),
    cartTotalDiscountable: getCartTotalDiscountable(state),
    cartTotalDiscounted: getCartTotalDiscountedCoupon(state),
    validCoupon: isValidCoupon(state),
    discount: getDiscount(state),
    advancedGa: state.store.data.features.advancedGa,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    uiVariantInputText: state.store.data.uiVariants.inputText,
    hasCriteo: state.store.data.features.hasCriteo,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    couponIsAppliedToSopOtc:
      state.store.data.funzionalita.couponIsAppliedToSopOtc,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    removeFromCart,
    updateCartQuantity,
    setCoupon,
    resetCoupon,
    getCoupon,
  })(Carrello)
);
